module.exports = __webpack_public_path__ + "static/media/sunny.f55dba49.svg";